import { ShieldCheck } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from '@/components/ui/tooltip';

export function GlassBoxBadge({ label = "Verified", txHash }) {
  const shortHash = txHash
    ? `${txHash.slice(0, 6)}...${txHash.slice(-4)}`
    : '0x7F...9A2';
  const fullHash = txHash || '0x7F4a2b9c1d3e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f9A2';

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-emerald-50/80 text-emerald-700 border border-emerald-200/50 backdrop-blur-sm text-xs font-medium cursor-pointer hover:bg-emerald-100/80 transition-colors"
            data-testid="glass-box-badge"
          >
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-600" />
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs bg-[#111827] text-white p-3 rounded-xl border-0">
          <p className="text-xs font-mono mb-1.5">Tx: {shortHash}</p>
          <a
            href={`https://bscscan.com/tx/${fullHash}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-emerald-400 hover:text-emerald-300 underline"
            data-testid="bscscan-link"
          >
            View on BscScan
          </a>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default GlassBoxBadge;
